import apiSlice from "./ApiSlice";

export const batchApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    getBatches: builder.query({
      providesTags: ["batches"],
      query: (body) => {
        return {
          url: "/batch",
          method: "POST",
          body,
        };
      },
    }),

    //Get All Student And Batch
    getAllBatcheAndStudentCount: builder.query({
      providesTags: ["batches", "student"],
      query: () => {
        return {
          url: "/dashboard/batch-student-count",
          method: "GET",
        };
      },
    }),

    // GET ALL
    getAllBatches: builder.query({
      providesTags: ["batches"],
      query: () => {
        return {
          url: "/batch",
          method: "GET",
        };
      },
    }),

    // GET BY ID
    getBatchById: builder.query({
      query: (batchId) => {
        return {
          url: `/batch/${batchId}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),

    // ADD
    addBatch: builder.mutation({
      invalidatesTags: ["batches"],
      query: (body) => {
        return {
          url: "/batch/add",
          method: "POST",
          body,
        };
      },
    }),

    // UPDATE
    updateBatch: builder.mutation({
      invalidatesTags: ["batches"],
      query: ({ body, batchId }) => {
        return {
          url: `/batch/${batchId}`,
          method: "PUT",
          body,
        };
      },
    }),

    // DELETE BY ID
    deleteBatch: builder.mutation({
      invalidatesTags: ["batches"],
      query: (batchId) => {
        return {
          url: `/batch/${batchId}`,
          method: "DELETE",
        };
      },
    }),
    // get All student in batch
    getAllStudentOfBatch: builder.query({
      providesTags: ["batches"],
      query: (body) => {
        return {
          url: "/attendance",
          method: "POST",
          body,
        };
      },
    }),

    //Update their attendance
    updateAttendance: builder.mutation({
      invalidatesTags: ["batches"],
      query: (body) => {
        return {
          url: `/attendance/update-student-status`,
          method: "PUT",
          body,
        };
      },
    }),
    //Update their attendance
    addAssignQuestion: builder.mutation({
      invalidatesTags: ["batches"],
      query: ({ batchId, questionId, assignstatus }: any) => {
        return {
          url: `/batch/${batchId}/question/${questionId}/assign/${assignstatus}`,
          method: "PUT",
        };
      },
    }),
    // Assigment get
    getBatchAssigment: builder.query({
      providesTags: ["batches"],
      query: (body) => {
        return {
          url: "/question/get-assigned-question",
          method: "POST",
          body,
        };
      },
    }),

    //Student Assignment Status
    getStudentAssigmentStatus: builder.query({
      providesTags: ["batches"],
      query: (body) => {
        return {
          url: "assignment/get-student-assignment-status",
          method: "POST",
          body,
        };
      },
    }),

    //Get All Days By batch
    getBatchDurationDays: builder.query({
      providesTags: ["batches"],
      query: (body) => {
        return {
          url: "/batch/day-wise-plan",
          method: "POST",
          body,
        };
      },
    }),

    //Get Single Day Data
    getSingleDayData: builder.query({
      providesTags: ["batches", "courses"],
      query: (id) => {
        return {
          url: `/batch/day-info/${id}`,
          method: "GET",
        };
      },
    }),
    /////////////  Recording ///////////////////////////
    //ADD Recording
    addRecording: builder.mutation({
      invalidatesTags: ["batches"],
      query: (body) => {
        return {
          url: "/recording/add",
          method: "POST",
          body,
        };
      },
    }),

    // GET Recordings List
    getAllRecording: builder.query({
      providesTags: ["batches"],
      query: (body) => {
        return {
          url: "/recording",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE BY ID Recording
    deleteRecording: builder.mutation({
      invalidatesTags: ["batches"],
      query: (id) => {
        return {
          url: `/recording/${id}`,
          method: "DELETE",
        };
      },
    }),

    // UPDATE
    updateRecording: builder.mutation({
      invalidatesTags: ["batches"],
      query: ({ body, id }) => {
        return {
          url: `/recording/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // GET BY ID Recording
    getRecordingById: builder.query({
      query: (id) => {
        return {
          url: `/recording/${id}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetBatchesQuery,
  useGetAllStudentOfBatchQuery,
  useGetAllBatchesQuery,
  useAddBatchMutation,
  useUpdateBatchMutation,
  useGetBatchByIdQuery,
  useDeleteBatchMutation,
  useUpdateAttendanceMutation,
  useAddAssignQuestionMutation,
  useGetBatchAssigmentQuery,
  useGetStudentAssigmentStatusQuery,
  useGetAllBatcheAndStudentCountQuery,
  useGetBatchDurationDaysQuery,
  useGetSingleDayDataQuery,
  useAddRecordingMutation,
  useGetAllRecordingQuery,
  useDeleteRecordingMutation,
  useUpdateRecordingMutation,
  useGetRecordingByIdQuery,
} = batchApi;
